import './EditorView.css';
import React, {Component} from 'react';
import PropTypes from "prop-types";
import Oscillator from "./tools/Oscillator";
import Gain from "./tools/Gain";
import BiquadFilter from "./tools/BiquadFilter";
import BufferSource from "./tools/BufferSource";
import Convolver from "./tools/Convolver";
import WaveShaper from "./tools/WaveShaper";
import ADSREnvelope from "./tools/ADSREnvelope";

class EditorView extends Component {
  static propTypes = {
    toolChain: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

  }

  render() {
    return (
      <div className={"editorView"}>
        <h3>Tool Chain</h3>
          {this.props.toolChain && this.props.toolChain.map((tool, index) => {
            const connectables = this.props.toolChain.filter(t2 => t2.id !== tool.id).map(t2 => t2.id);
            switch(tool.type) {
              case "adsrenvelope":
                return <ADSREnvelope
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>
              case "biquadFilter":
                return <BiquadFilter
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>
              case "bufferSource":
                return <BufferSource
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>
              case "convolver":
                return <Convolver
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>
              case "gain":
                return <Gain
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>
              case "oscillator":
                return <Oscillator
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>;
              case "waveShaper":
                return <WaveShaper
                    key={index}
                    config={tool}
                    connectables={connectables}
                    deleteTool={this.props.deleteTool}
                    setToolConfig={this.props.setToolConfig}/>;

                default:
                  return <div key={index}>Unknown tool type: {tool.type}</div>;
            }
            })}
      </div>
    );
  }
}

export default EditorView;